import { put, takeLatest } from 'redux-saga/effects';
import history from '../../../history';
import OrganizationService from '../../../services/OrganizationService';
import {
  getOrganizationRequest,
  getOrganizationFail,
  getOrganizationSuccess,
  getOrganizationListRequest,
  getOrganizationListFail,
  getOrganizationListSuccess,
  saveOrganizationRequest,
  saveOrganizationFail,
  saveOrganizationSuccess,
  createOrganizationRequest,
  createOrganizationSuccess,
  createOrganizationFail,
  deleteOrganizationRequest,
  deleteOrganizationSuccess,
  deleteOrganizationFail,
  setOrganizationListDirty,
  initOrganizationRequest,
  initOrganizationSuccess,
  initOrganizationFail,
  clearOrganizationList,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';
import { getRoleFromPath } from '../../../utility/path';
import { getCurrentUserRequest } from '../users/actions';

function* getOrganizationList({
  payload,
}: ReturnType<typeof getOrganizationListRequest>) {
  try {
    const list = yield apiCall(OrganizationService.list, payload);
    yield put(getOrganizationListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getOrganizationListFail());
  }
}

function* getOrganization({
  payload,
}: ReturnType<typeof getOrganizationRequest>) {
  try {
    const list = yield apiCall(OrganizationService.get, payload);
    yield put(getOrganizationSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getOrganizationFail());
  }
}

function* saveOrganization({
  payload,
}: ReturnType<typeof saveOrganizationRequest>) {
  try {
    const response = yield apiCall(
      OrganizationService.save,
      payload.id,
      payload,
    );
    yield put(saveOrganizationSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveOrganizationFail());
  }
}

function* createOrganization({
  payload,
}: ReturnType<typeof createOrganizationRequest>) {
  try {
    const response = yield apiCall(OrganizationService.create, payload);
    const role = getRoleFromPath(history.location.pathname);
    history.push(`/dashboard/${role}/organizations/${response.id}`);
    yield put(createOrganizationSuccess(response));
    yield put(getCurrentUserRequest());
  } catch (e) {
    yield put(initOrganizationSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createOrganizationFail());
  }
}

function* deleteOrganization({
  payload,
}: ReturnType<typeof deleteOrganizationRequest>) {
  try {
    yield apiCall(OrganizationService.delete, payload);
    yield put(deleteOrganizationSuccess());
    yield put(setOrganizationListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(deleteOrganizationFail());
  }
}

function* getTemplateOrganization() {
  try {
    const response = yield apiCall(OrganizationService.template);
    yield put(initOrganizationSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initOrganizationFail());
  }
}

function* clearList() {
  yield put(clearOrganizationList());
}

export default [
  takeLatest(getOrganizationListRequest.type, getOrganizationList),
  takeLatest(getOrganizationRequest.type, getOrganization),
  takeLatest(saveOrganizationRequest.type, saveOrganization),
  takeLatest(createOrganizationRequest.type, createOrganization),
  takeLatest(deleteOrganizationRequest.type, deleteOrganization),
  takeLatest(initOrganizationRequest.type, getTemplateOrganization),
  takeLatest(logOut.type, clearList),
];
